// Custom JS code for Quiz Page 

const section__quiz_page_overlay = document.querySelector(".section__quiz-page-overlay");

const main_quiz_container = document.querySelector(".main_quiz_container");

const quiz_page__back_button_container = document.querySelector(".quiz-page__back-button_container");
const quiz_page__back_button = document.querySelector(".quiz-page__back-button");
const quiz_page_content = document.querySelector(".quiz-page-content");
const recommendation_page_content = document.querySelector(".recommendation-page-content");
const loading_spinner_container = document.querySelector(".loading_spinner_container");

const question_item_name = document.querySelector("#question_item-name");
const name_input = question_item_name.querySelector("#name");
const name_submit_btn = question_item_name.querySelector(".submit_btn");

const question_item_age = document.querySelector("#question_item-age");
const age_input = question_item_age.querySelector("#age");
const age_submit_btn = question_item_age.querySelector(".submit_btn");

const question_item_phone = document.querySelector("#question_item-phone");
const phone_input = question_item_phone.querySelector("#phone");
const phone_submit_btn = question_item_phone.querySelector(".submit_btn");

const question_item_email = document.querySelector("#question_item-email");
const email_input = question_item_email.querySelector("#k_id_email");
const email_submit_btn = question_item_email.querySelector(".submit_btn");

const question_item_gender = document.querySelector("#question_item-gender");
const male = question_item_gender.querySelector("#male");
const female = question_item_gender.querySelector("#female");
const other = question_item_gender.querySelector("#other");

const finished_container = document.querySelector(".finished_container");
const finished_button = document.querySelector(".finished_button");

const question_items = document.querySelectorAll(".question_item");
const quiz_question_items = document.querySelectorAll(".quiz_question_item");
const answer_items = document.querySelectorAll(".answer_item");
const quiz_answer_items = document.querySelectorAll(".quiz_answer_item");

const recommendation_section__title = document.querySelector(".recommendation_section__title");
const restart_quiz = document.querySelector(".restart_quiz");

const open_bundle_cart = document.querySelector(".open_bundle_cart");
const cart_bundle_page = document.querySelector(".cart-bundle-page");
const cart_bundle__back_button = document.querySelector(".cart-bundle__back-button");


const same_item_answers_freq = {}
const answered_questions_yes = []
let answered_questions_count = 0

let name = ""
let age = ""
let phone = ""
let gender = ""
let email = ""

let quiz_data = {
    "Name":"",
    "Age": "",
    "Phone": "",
    "Gender": "",
    "Email": "",
    "AnswersCount":"",
    "YesAnswers": []
}

let quiz_questions = {}


// Update progress bar initially
const progressBar = document.getElementById('progress-bar');
const progressBarLabel = document.getElementById('progress-bar-label');

function updateProgressBar(progressPercentage) {
    
    // Update the progress bar width
    progressBar.style.width = `${progressPercentage}%`;

    // Update the progress bar label text and position
    progressBarLabel.innerText = `${answered_questions_count}/${question_items.length}`;
    const labelWidth = progressBarLabel.offsetWidth;
    const barWidth = progressBar.offsetWidth;
    const labelLeft = (progressPercentage / 100) * barWidth - (labelWidth / 2);
    if(progressPercentage >= 100){
        progressBarLabel.style.left = `97%`;
    }else{
        progressBarLabel.style.left = `${progressPercentage}%`;
    }
}

let progressPercentage = (answered_questions_count/question_items.length)*100;
updateProgressBar(Math.round(progressPercentage));


// Set stored quiz data

function setQuizValues(){
    if(localStorage.getItem("quiz_data")){
        quiz_data = JSON.parse(localStorage.getItem("quiz_data"));
        name_input.value = quiz_data["Name"];
        age_input.value = quiz_data["Age"];
        email_input.value = quiz_data["Email"];
        if(quiz_data["Gender"]){
            question_item_gender.querySelector(`label#${quiz_data["Gender"]}`).click();
        }

        quiz_page__back_button.dataset.prevIndex = quiz_data["AnswersCount"]-1;
        answered_questions_count = quiz_data["AnswersCount"];
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        
        let currentIndex = quiz_data["AnswersCount"]; 
        for (let i = 0; i < question_items.length; i++) {

            if(currentIndex <= question_items.length-1){
                if(i != currentIndex){
                    question_items[i].classList.add("hidden");
                }else{
                    question_items[i].classList.remove("hidden");
                }
            }else if(quiz_data["showRecommendation"] == 0){
                finished_container.classList.remove("hidden");
                question_items[i].classList.add("hidden");
                main_quiz_container.classList.remove("main_quiz_container_bg")
            }else{
                recommendation_page_content.classList.remove("hidden");
                main_quiz_container.classList.add("main_quiz_container_bg")
                quiz_page_content.classList.add("hidden");
                question_items[i].classList.add("hidden");
            }
        }

        if(answered_questions_count>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }

        if(quiz_data["openBundle"]){
            cart_bundle_page.classList.remove("hidden");
            main_quiz_container.classList.add("hidden");
        }
        
        setCartQuantities();

        section__quiz_page_overlay.classList.remove("section__quiz-page-overlay");
    }
}

setQuizValues();

// Get name
name_submit_btn.addEventListener("click",function(e){
    e.preventDefault();
    if(name_input.value.length > 2 && name_input.value != " "){
        name = name_input.value;
        quiz_data["Name"] = name_input.value;

        recommendation_section__title.innerText = `Just For ${quiz_data["Name"]}`
        
        question_item_name.classList.add("hidden");
        question_item_age.classList.remove("hidden");
        
        
        quiz_page__back_button.dataset.prevIndex = answered_questions_count;
        if(answered_questions_count>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }
        
        // Increase progress bar
        answered_questions_count++;
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        quiz_data["AnswersCount"] = answered_questions_count;
        
        localStorage.setItem("quiz_data",JSON.stringify(quiz_data));

    }else{
        alert("Error: Name cannot have less then 3 characters.");
    }
})
name_input.addEventListener("keypress",function(e){
    if (e.key === "Enter") {
        e.preventDefault();
        name_submit_btn.click();
    }
})

// Get age
age_submit_btn.addEventListener("click",function(e){
    e.preventDefault();
    if(parseInt(age_input.value) >= 18){
        age = parseInt(age_input.value);
        quiz_data["Age"] = parseInt(age_input.value);
        
        question_item_age.classList.add("hidden");
        question_item_gender.classList.remove("hidden");
        
        
        quiz_page__back_button.dataset.prevIndex = answered_questions_count;
        if(answered_questions_count>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }
        
        // Increase progress bar
        answered_questions_count++;
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        quiz_data["AnswersCount"] = answered_questions_count;
        
        localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
    }else{
        alert("Error: Age cannot be less than 18.");
    }
})
age_input.addEventListener("keypress",function(e){
    if (e.key === "Enter") {
        e.preventDefault();
        age_submit_btn.click();
    }
})

// Phone validation function
function validatePhone(phone) {
    const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return regex.test(phone);
}

// Get phone
phone_submit_btn.addEventListener("click",function(e){
    e.preventDefault();
    if(phone_input.value.length != "" && validatePhone(phone_input.value)){
        const klaviyo_phone_input = document.querySelector("#k_id_phone");
        phone = phone_input.value;
        quiz_data["Phone"] = phone_input.value;
        klaviyo_phone_input.value = phone_input.value;
        
        question_item_phone.classList.add("hidden");
        question_item_email.classList.remove("hidden");
        
        quiz_page__back_button.dataset.prevIndex = answered_questions_count;
        if(answered_questions_count>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }
        
        // Increase progress bar
        answered_questions_count++;
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        quiz_data["AnswersCount"] = answered_questions_count;
        
        localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
    }else{
        alert("Error: Use correct phone# format. Example - (111) 222-3333.");
    }
})
phone_input.addEventListener("keypress",function(e){
    if (e.key === "Enter") {
        e.preventDefault();
        phone_submit_btn.click();
    }
})

// Get gender
const question_item_gender_values = question_item_gender.querySelectorAll("label");
for(let i=0; i<question_item_gender_values.length; i++){

    question_item_gender_values[i].addEventListener("click",function(){
        quiz_page__back_button.dataset.prevIndex = answered_questions_count;
        if(answered_questions_count>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }
    
        // Increase progress bar
        answered_questions_count++;
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        quiz_data["AnswersCount"] = answered_questions_count;
    
        gender = this.innerText.toLowerCase();
        quiz_data["Gender"] = this.innerText.toLowerCase();
        localStorage.setItem("quiz_data",JSON.stringify(quiz_data));

        
    
        question_item_gender.classList.add("hidden");
        question_items[answered_questions_count].classList.remove("hidden");
    })
}

// Email validation function
function validateEmail(email) {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}
  

// Get email
email_submit_btn.addEventListener("click",function(e){
    if(email_input.value.length != "" && validateEmail(email_input.value)){

        document.getElementById('k_id_age').value        = quiz_data.Age || '';
        document.getElementById('k_id_gender').value     = quiz_data.Gender || '';

        document.querySelector("#klaviy_form_submit_btn").click();
        email = email_input.value;
        quiz_data["Email"] = email_input.value;
       

        
        question_item_email.classList.add("hidden");
        quiz_page_content.classList.add("hidden");
        loading_spinner_container.classList.remove("hidden");

        const recommendation_timeout = setTimeout(()=>{
            loading_spinner_container.classList.add("hidden");
            recommendation_page_content.classList.remove("hidden");
            main_quiz_container.classList.add("main_quiz_container_bg")

            quiz_page__back_button.dataset.prevIndex = quiz_data["AnswersCount"]-1;
            quiz_data["showRecommendation"] = 1;

            localStorage.setItem("quiz_data",JSON.stringify(quiz_data));

            showRecommendationProducts();
        },3000)
        
        quiz_page__back_button.dataset.prevIndex = answered_questions_count;
        if(answered_questions_count>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }
        
        // Increase progress bar
        answered_questions_count++;
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        quiz_data["AnswersCount"] = answered_questions_count;
        
        localStorage.setItem("quiz_data",JSON.stringify(quiz_data));


    }else{
        alert("Error: Enter a valid email");
    }
})
email_input.addEventListener("keypress",function(e){
    if (e.key === "Enter") {
        e.preventDefault();
        email_submit_btn.click();
    }
})

// Quiz questions
function setAnwersEvents(){
    for(let i=0; i<quiz_answer_items.length; i++){
        quiz_answer_items[i].querySelector("label").addEventListener("click",function(){

            if(this.dataset.question in quiz_questions === false){
                const klaviyo_email_form = document.querySelector("#question_item-email form#email_signup");
                const klaviyo_input_$fields = document.getElementsByName("$fields");
                
                klaviyo_input_$fields[0].value = `${klaviyo_input_$fields[0].value}, ${this.dataset.question.replaceAll(",",";")}`;
                
                const q_node = document.createElement("input");
                q_node.classList.add("hidden");
                q_node.type = 'text'
                q_node.name = this.dataset.question.replaceAll(',',';');
                q_node.setAttribute("value",this.querySelector("span").innerText.toLowerCase())

                klaviyo_email_form.appendChild(q_node)
                quiz_questions[this.dataset.question] = this.querySelector("span").innerText.toLowerCase();
            }else{
                let currentQuestion = document.getElementsByName(this.dataset.question);
                currentQuestion[0].setAttribute("value",this.querySelector("span").innerText.toLowerCase())

                quiz_questions[this.dataset.question] = this.querySelector("span").innerText.toLowerCase();
            }
            quiz_data["questionsList"] = quiz_questions;


            // Increase progress bar
            answered_questions_count++;
            let progressPercentage = (answered_questions_count/question_items.length)*100;
            updateProgressBar(Math.round(progressPercentage));
            quiz_data["AnswersCount"] = answered_questions_count;


            // Hide and show questions
            for(let j=0; j<question_items.length; j++){
                let currentAnswerId = this.id.split("-");
                let question_itemsId = question_items[j].id.split("-");
                if(question_itemsId[1]==(currentAnswerId[1])){
                    
                    // set back button value
                    quiz_page__back_button.dataset.prevIndex = j;
                    if(answered_questions_count>=0){
                        quiz_page__back_button.href = "#!";
                    }else{
                        quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
                    }

                    question_items[j].classList.add("hidden");

                    if(j+1 <= question_items.length-1){
                        question_items[j+1].classList.remove("hidden");
                    }
                    else if(j == question_items.length-1){
                        quiz_page_content.classList.add("hidden");
                        loading_spinner_container.classList.remove("hidden");

                        const recommendation_timeout = setTimeout(()=>{
                            loading_spinner_container.classList.add("hidden");
                            recommendation_page_content.classList.remove("hidden");
                            main_quiz_container.classList.add("main_quiz_container_bg")

                            quiz_page__back_button.dataset.prevIndex = quiz_data["AnswersCount"]-1;
                            quiz_data["showRecommendation"] = 1;
    
                            localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
                        },3000)
                    }

                    // Add yes answered questions to an array.
                    const productHandle = quiz_answer_items[i].dataset.productHandle;
                    let btn_ans = this.querySelector("span").innerHTML
                    if(btn_ans.toLowerCase() == "yes" && answered_questions_yes.includes(productHandle) == false){
                        answered_questions_yes.push(productHandle);
                        same_item_answers_freq[productHandle] = 1;
                    }
                    else if(btn_ans.toLowerCase() == "yes" && answered_questions_yes.includes(productHandle) == true){
                        same_item_answers_freq[productHandle] += 1;
                    }
                    // remove no answered questions from array.
                    else if(btn_ans.toLowerCase() == "no" && answered_questions_yes.includes(productHandle) == true){
                        if(same_item_answers_freq[productHandle] == 0){
                            const index = answered_questions_yes.indexOf(productHandle);
                            if (index > -1) { 
                                answered_questions_yes.splice(index, 1);
                            }
                        }
                        same_item_answers_freq[productHandle] -= 1;
                    }
                    quiz_data["YesAnswers"] = answered_questions_yes;
                    quiz_data["sameAnswersFreq"] = same_item_answers_freq;
                }
            }

            localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
            
        })
    }
}

setAnwersEvents();

// Back button
quiz_page__back_button.addEventListener("click",function(){
    if(parseInt(this.dataset.prevIndex)<0){
        quiz_page__back_button.href = "/";
    }else{

        if(parseInt(this.dataset.prevIndex)+1<=question_items.length-1){
    
            
            question_items[parseInt(this.dataset.prevIndex)+1].classList.add("hidden");
            question_items[parseInt(this.dataset.prevIndex)].classList.remove("hidden");
        }else{
            finished_container.classList.add("hidden");
            question_items[parseInt(this.dataset.prevIndex)].classList.remove("hidden");
        }
    
        if(quiz_page_content.classList.contains("hidden")){
            quiz_page_content.classList.remove("hidden");
            recommendation_page_content.classList.add("hidden");
            main_quiz_container.classList.remove("main_quiz_container_bg")

            quiz_data["showRecommendation"] = 0;
        }
    
        quiz_page__back_button.dataset.prevIndex = parseInt(this.dataset.prevIndex) - 1;
    
    
        // Decrease progress bar
        answered_questions_count--;
        let progressPercentage = (answered_questions_count/question_items.length)*100;
        updateProgressBar(Math.round(progressPercentage));
        quiz_data["AnswersCount"] = answered_questions_count;
    
        localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
    
        if(answered_questions_count-1>=0){
            quiz_page__back_button.href = "#!";
        }else{
            quiz_page__back_button_container.innerHTML = `<a class="quiz-page__back-button" href="/" data-prev-index="">Back</a>`;
        }
    }
})

// Updating recommedation title & products
function setRecommendationPage(){
    if(localStorage.getItem("quiz_data")){
        recommendation_section__title.innerText = `Just For ${quiz_data["Name"]}`
    }
}

setRecommendationPage();

function showRecommendationProducts(){
    const recommendation_products_items = document.querySelectorAll(".recommendation-products-item");
    const no_recommedations = document.querySelector(".no_recommedations");

    if(quiz_data["YesAnswers"].length<1){
        open_bundle_cart.innerText = "Click To See More";
        document.querySelector("#recommendation_products .deals-scroll-left").classList.add("hidden");
        document.querySelector("#recommendation_products .deals-scroll-right").classList.add("hidden");

    }else{
        open_bundle_cart.innerText = "Continue";
        document.querySelector("#recommendation_products .deals-scroll-left").classList.remove("hidden");
        document.querySelector("#recommendation_products .deals-scroll-right").classList.remove("hidden");
    }
    for (let i = 0; i < recommendation_products_items.length; i++) {
        if(quiz_data["YesAnswers"].includes(recommendation_products_items[i].dataset.productHandle)){
            recommendation_products_items[i].classList.remove("hidden");
        }else{
            recommendation_products_items[i].classList.add("hidden");
        }
    }
}

showRecommendationProducts()


// Updating cart suggestions
function showSuggentionsProducts(){
    const suggestions_products_items = document.querySelectorAll(".suggestions-product-item");
    for (let i = 0; i < suggestions_products_items.length; i++) {
        if(quiz_data["YesAnswers"].includes(suggestions_products_items[i].dataset.productHandle)){
            suggestions_products_items[i].classList.add("hidden");
        }else{
            suggestions_products_items[i].classList.remove("hidden");
        }
    }
}

showSuggentionsProducts()

// Removing cart items
function bundleCartCloseBtns(){
    const cart_product_list = document.querySelector(".cart-product-list");
    const cart_bundle_items = document.querySelectorAll(".cart-bundle-item");
    const cart_item_close_icons = document.querySelectorAll(".cart-item_close");

    for (let i = 0; i < cart_item_close_icons.length; i++) {
        cart_item_close_icons[i].addEventListener("click",()=>{
            cart_item_close_icons[i].parentNode.removeChild(cart_item_close_icons[i]);

            if(cart_item_close_icons[i].dataset.productHandle == cart_bundle_items[i].dataset.productHandle){
                cart_bundle_items[i].parentNode.removeChild(cart_bundle_items[i]);
                
                quiz_data["bundleCartProducts"] = quiz_data["bundleCartProducts"].filter(function(el) { return el.handle != cart_bundle_items[i].dataset.productHandle; }); 
                
                localStorage.setItem("quiz_data",JSON.stringify(quiz_data));

                showSuggentionsProducts();
                bundleCartATC();
            }
        })
    }

}

bundleCartCloseBtns()

// Set Cart Quantities
function setCartQuantities(){
    const qty_inputs = document.querySelectorAll(".js-qty-input");
    for (let i = 0; i < qty_inputs.length; i++) {
        let currProdId = qty_inputs[i].id.split("_");
        let objIndex = quiz_data["bundleCartProducts"].findIndex((obj => obj.id == parseInt(currProdId[1])));
        if(quiz_data["bundleCartProducts"][objIndex]){

            qty_inputs[i].value = quiz_data["bundleCartProducts"][objIndex].qty;
        }
    }
}

// Bundle Cart Quantity buttons
function decreaseQty(){
    const qty__adjust__minus = document.querySelectorAll(".js-qty__adjust--minus");
    for (let i = 0; i < qty__adjust__minus.length; i++) {
        qty__adjust__minus[i].addEventListener("click",()=>{
            let currInputId = qty__adjust__minus[i].id.split("-");
            const currQtyInput = document.querySelector(`#${currInputId[0]}`);
            if(currQtyInput.value > 1){
                currQtyInput.value = parseInt(currQtyInput.value) - 1;
            }

            let currProdId = currInputId[0].split("_");
            let objIndex = quiz_data["bundleCartProducts"].findIndex((obj => obj.id == parseInt(currProdId[1])));
            quiz_data["bundleCartProducts"][objIndex].qty = parseInt(currQtyInput.value);

            localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
            bundleCartATC()
        })
    }
}

decreaseQty();

function increaseQty(){
    const qty__adjust__plus = document.querySelectorAll(".js-qty__adjust--plus");
    for (let i = 0; i < qty__adjust__plus.length; i++) {
        qty__adjust__plus[i].addEventListener("click",()=>{
            let currInputId = qty__adjust__plus[i].id.split("-");
            const currQtyInput = document.querySelector(`#${currInputId[0]}`);
            if(currQtyInput.value < 20){
                currQtyInput.value = parseInt(currQtyInput.value) + 1;
            }

            let currProdId = currInputId[0].split("_");
            let objIndex = quiz_data["bundleCartProducts"].findIndex((obj => obj.id == parseInt(currProdId[1])));
            quiz_data["bundleCartProducts"][objIndex].qty = parseInt(currQtyInput.value);

            localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
            bundleCartATC()
        })
    }
}

increaseQty();

// Add to bundle buttons setup
function addToBundleButtonsSetup(){
    const suggestions_products_items = document.querySelectorAll(".suggestions-product-item");
    const add_to_bundle_btns = document.querySelectorAll(".add_to_bundle_btn");
    for (let i = 0; i < add_to_bundle_btns.length; i++) {
        add_to_bundle_btns[i].addEventListener("click",()=>{
            if(quiz_data["YesAnswers"].includes(add_to_bundle_btns[i].dataset.productHandle) == false){
                addProductToBundle(add_to_bundle_btns[i].dataset.productId,add_to_bundle_btns[i].dataset.productHandle);
            }
            suggestions_products_items[i].classList.add("hidden");
            setCartQuantities();
        })
    }
}

addToBundleButtonsSetup();

// Bundle Cart ATC
function bundleCartATC(){
    const cart_bundle_atc_container = document.querySelector(".cart-bundle_atc-container");
    const add_bundle_to_cart_btn = document.querySelector(".add-bundle-to-cart_btn");

    let permalink = '/cart/'
    
    if(quiz_data["bundleCartProducts"]){

        for (let i = 0; i < quiz_data["bundleCartProducts"].length; i++) {
            if(quiz_data["bundleCartProducts"].length-1 == i){
                permalink = permalink + `${quiz_data["bundleCartProducts"][i].variantId}:${quiz_data["bundleCartProducts"][i].qty}`
            }else{
                permalink = permalink + `${quiz_data["bundleCartProducts"][i].variantId}:${quiz_data["bundleCartProducts"][i].qty},`
            }
        }
    }


    cart_bundle_atc_container.innerHTML = `<a href="${permalink}" class="c-btn c-btn--primary add-bundle-to-cart_btn">Add Bundle to Cart</a>
    `
}

bundleCartATC();

// Open bundle cart
open_bundle_cart.addEventListener("click",function(){
    cart_bundle_page.classList.remove("hidden");
    main_quiz_container.classList.add("hidden");

    quiz_data["openBundle"] = 1;
        
    localStorage.setItem("quiz_data",JSON.stringify(quiz_data));

    setBundleCart();
    bundleCartCloseBtns();
    decreaseQty();
    increaseQty();
    addToBundleButtonsSetup();
    bundleCartATC();
    setCartQuantities();
    showSuggentionsProducts();
})

// Bundle cart back button
cart_bundle__back_button.addEventListener("click",function(){
    cart_bundle_page.classList.add("hidden");
    main_quiz_container.classList.remove("hidden");

    quiz_data["openBundle"] = 0;
        
    localStorage.setItem("quiz_data",JSON.stringify(quiz_data));
    
    showRecommendationProducts()
})

// Restart Quiz
restart_quiz.addEventListener("click",function(){
    localStorage.removeItem("quiz_data");
    location.reload()
})

// Card Slider

let isAnimating = false;

function scrollLeftAnimate(elem, unit) {
  if (!elem || isAnimating) {
    //if element not found / if animating, do not execute slide
    return;
  }

  let time = 300; // animation duration in MS, the smaller the faster.
  let from = elem.scrollLeft; // to continue the frame posistion
  let aframe = 10; //fraction of frame frequency , set 1 for smoothest  ~ set 10++ for lower FPS (reduce CPU usage)
  isAnimating = true; //if animating prevent double trigger animation

  let start = new Date().getTime(),
    timer = setInterval(function () {
      let step = Math.min(1, (new Date().getTime() - start) / time);
      elem.scrollLeft = step * unit + from;
      if (step === 1) {
        clearInterval(timer);
        isAnimating = false;
      }
    }, aframe);
}

function initDealCarrousel(dealCarrouselID) {
  let target = document.querySelector(
    "#" + dealCarrouselID + " .recommendation-products-list"
  );
  let cardOutterWidth;
  let maxCarrouselScroll;

  function updateUpaCarrouselInfo() {
    cardOutterWidth = document.querySelector(
      "#" + dealCarrouselID + " .recommendation-products-item"
    ).offsetWidth; //you can define how far the scroll
    maxCarrouselScroll =
      document.querySelectorAll("#" + dealCarrouselID + " .recommendation-products-item").length *
        cardOutterWidth -
      document.querySelector("#" + dealCarrouselID + " .recommendation-products-list")
        .clientWidth;
  }

  document
    .querySelector("#" + dealCarrouselID + " .deals-scroll-left")
    .addEventListener("click", function () {
      updateUpaCarrouselInfo(); //in case window resized, will get new info
      if (target.scrollLeft > 0) {
        scrollLeftAnimate(target, -cardOutterWidth * 2);
      }
    });

  document
    .querySelector("#" + dealCarrouselID + " .deals-scroll-right")
    .addEventListener("click", function () {
      updateUpaCarrouselInfo(); //in case window resized, will get new info
      if (target.scrollLeft < maxCarrouselScroll) {
        scrollLeftAnimate(target, cardOutterWidth * 2);
      }
    });
}
// Initiate the containers with IDs
initDealCarrousel("recommendation_products"); //carrousel ID
initDealCarrousel("cart-bundle_suggestions-container"); //carrousel ID
